// extracted by mini-css-extract-plugin
export var chip = "_5v-9";
export var chipLabel = "_5v-a";
export var close = "_5v-7";
export var closeIcon = "_5v-8";
export var error = "_5v-6";
export var infoTooltip = "_5v-2";
export var innerContainer = "_5v-1";
export var input = "_5v-b";
export var medium = "_5v-5";
export var outerContainer = "_5v-0";
export var small = "_5v-4";
export var xSmall = "_5v-3";